<template>
    <div class="flex items-center space-x-2 w-full" v-if="userName">
        <!-- User Link -->
        <router-link :to="`user/${userId}`" class="hover:font-semibold flex-grow">
            {{ capitalizeName }}
        </router-link>

        <!-- Edit Icon and Dropdown -->
        <v-menu v-model="menu" offset-y bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click.stop="menu = !menu" class="ml-4" title="Update the account type"
                    color="grey" size="medium">
                    mdi-pencil
                </v-icon>
            </template>
            <v-list>
                <v-list-item v-for="option in options" :key="option" :value="option" @click="handleOptionClick(option)"
                    :class="{
                        'bg-gray-100': option.toLowerCase() === selectedOption.toLowerCase()
                    }">
                    <v-list-item-title>
                        <span :class="badgeClass(option)">
                            {{ option }}
                        </span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "MatrixCellLink",
    data() {
        return {
            userId: 0,
            employerId: 0,
            userName: "",
            accountId: 0,
            accountType: "unknown",
            menu: false,
            options: ["Customer", "Prospect", "Unknown"],
            selectedOption: "Unknown",
        };
    },
    beforeMount() {
        const { id, name, account_id, account_type, employer_id } = this.params.value;
        this.userId = id;
        this.accountId = account_id;
        this.employerId = employer_id
        this.userName = name ? name : "";
        this.accountType = account_type ? account_type.toLowerCase() : "unknown";
        this.selectedOption = this.capitalizeOption(this.accountType);
    },
    computed: {
        capitalizeName() {
            return this.userName
                .split(" ")
                .map(
                    (n) => `${n.toUpperCase().slice(0, 1)}${n.toLowerCase().slice(1)}`
                )
                .join(" ");
        },
    },
    methods: {
        handleOptionClick(option) {
            const newAccountType = option.toLowerCase();
            this.menu = false;

            this.$store.commit('updateAccountType', {
                userId: this.userId,
                accountId: this.accountId,
                employerId: this.employerId,
                newAccountType: newAccountType
            });
            this.selectedOption = option;
        },
        badgeClass(option) {
            switch (option.toLowerCase()) {
                case "customer":
                    return "inline-flex items-center rounded-md bg-green-100 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-100";
                case "prospect":
                    return "inline-flex items-center rounded-md bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-100";
                case "unknown":
                    return "inline-flex items-center rounded-md bg-red-100 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-100";
                default:
                    return "inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-100";
            }
        },
        capitalizeOption(option) {
            return option.charAt(0).toUpperCase() + option.slice(1);
        },
    },
};
</script>

<style scoped>
a {
    transition: font-weight 0.2s ease-in;
}

a:hover {
    font-weight: 600;
}
</style>